// @ts-expect-error unknown type
export const NoData = ({message}) => {
  message = message || "No data found. Try adjusting time range.";
  return (
    <div className="no-data-container">
      <div className="no-data-text">{message}</div>
    </div>
  );
};
